export default __webpack_public_path__ + "./image/54c3a0a368ffcfa164205c0f401c5c1b.png";